export const cardsTourSelectors = {
  getMenuButton: (ariaLabel: string) => () =>
    document.querySelector(`button[aria-label="${ariaLabel}"], a[aria-label="${ariaLabel}"]`) as HTMLElement,

  getTopGameCard: () => document.querySelector('article[aria-roledescription="draggable"]') as HTMLElement,
}
